import React from "react";
import './disclaimer.css';

const Disclaimer = ()=>{
    return(
        <>
        <div className="disclaimer">
            <div className="disclaimer-container">
                <p className="header">Disclaimer</p>
                <p className="disclaimer-content">
                Agrix Agrotech Private Limited cannot and does not warrant the completeness or accuracy of the news, information, or other content found on our website, or its usefulness for any purpose.

Certain areas of this site may feature or include content by third parties or links to third parties. You understand and acknowledge that Agrix Agrotech Private Limited is not responsible for such content.

You agree that Agrix Agrotech Private Limited shall not be liable for any decision made or action taken by you based upon reliance on any material or information published on our website.

We make no promises that our service(s) will be delivered to you uninterrupted, secure, error-free or delivered in a timely manner.

Under no circumstances will Agrix Agrotech Private Limited or any of its associates or service providers be liable for any expense, loss or damage including, without limitation, indirect or consequential loss or damage, or any expense, loss or damage whatsoever arising from use, or loss of use, of data, arising out of or in connection with the use of this website.
         </p>
            </div>
        </div>
        
        </>
    )
}

export default Disclaimer;